import { default as React, useState } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import SearchOption from "./searchOption";
import Collapsible from 'react-collapsible';
const s = require("./search.module.scss");


interface OwnState {
    search: (params: any) => void;
    isLoading: boolean;
    /*filter: { totalRows: number, totalRowsWithFilter: number, maxRows: number };*/
    searchFields?: SearchField[];
}
export interface SearchField {
    title: string;
    parameter: string;
    type: string;
    options?: Option[];
    defaultValue?: any;
}
export interface Option {
    title: string;
    value: any;
}

type SearchProps = OwnState & WithTranslation;

const SearchField = ({ search, isLoading, /*filter,*/ searchFields, t }: SearchProps) => {

    const [searchOptions, setSearchOptions] = useState({});
    const [reset, setReset] = useState(false);

    const setOptionValue = (option: string, value: any) => {
        const newFilter = {
            ...searchOptions,
            [option]: value
        };
        setSearchOptions(newFilter);
        search(newFilter);
    }

    const resetFilter = () => {
        (document.getElementById("searchForm") as HTMLFormElement).reset();
        setReset(true);
        setSearchOptions({});
        search({});
    }

    return (
        searchFields == undefined || searchFields == null || searchFields.length == 0 ? <></>
            : <div style={{ backgroundColor: "#f5f5f5", marginTop: "10px" }}>
                <Collapsible
                    onClosing={() => (document.getElementsByClassName('Collapsible__contentOuter')[0] as HTMLElement).style.overflow = 'hidden'}
                    onOpen={() => (document.getElementsByClassName('Collapsible__contentOuter')[0] as HTMLElement).style.overflow = 'inherit'}
                    trigger={
                        <div className={s.collapsible}>
                            <span className={s.searchLabel}>{t("common:filter")}</span>
                            <i className={s.collapsibleArrow}></i>
                        </div>
                    }>
                    <div className="inputlabel" style={{ display: "inline-block" }}>
                        <form id="searchForm" onSubmit={e => e.preventDefault()}>
                            <table><tbody>
                                {
                                    searchFields.map(field =>
                                        <SearchOption
                                            key={field.parameter}
                                            option={field}
                                            reset={reset}
                                            setReset={setReset}
                                            setOptionValue={setOptionValue} />)
                                }
                                <tr style={{ borderTop: '1px solid #757575' }}>
                                    <td>
                                        <button style={{ marginBottom: "3px" }} onClick={() => resetFilter()}>
                                            {t("common:reset").toString()}
                                        </button>
                                    </td>
                                </tr>
                            </tbody></table>
                        </form>
                    </div>

                </Collapsible>
            </div>
    );
};

export default withTranslation()(SearchField);
